import { z } from "zod/v4";
import { membershipFeeResponseSchema, stripeProductResponseSchema } from "../../schemas/finance";
import { fetchApi, fetchVoid } from "../client/internal";

export const fees = {
	list: (clubId: string) => fetchApi(`/${clubId}/fees`, z.array(membershipFeeResponseSchema)),
	create: (clubId: string, data: unknown) =>
		fetchApi(`/${clubId}/fees`, membershipFeeResponseSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (clubId: string, feeId: string, data: unknown) =>
		fetchApi(`/${clubId}/fees/${feeId}`, membershipFeeResponseSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, feeId: string) =>
		fetchVoid(`/${clubId}/fees/${feeId}`, { method: "DELETE" }),
	syncProduct: (clubId: string, feeId: string) =>
		fetchApi(`/${clubId}/fees/${feeId}/products`, stripeProductResponseSchema, {
			method: "POST",
		}),
};
